import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="brand" aria-label="Site">
          <span className="brand-badge" />
          <span>Shubhajeet Pradhan</span>
        </div>
        {/* <div style={{ display: 'flex', gap: 16 }}>
          <a href="mailto:shubha.pradhan12@gmail.com" aria-label="Email">Email</a>
          <a href="https://github.com/shubhajeet1207" target="_blank" rel="noreferrer" aria-label="GitHub">GitHub</a>
          <a href="https://www.linkedin.com/in/shubhajeet-pradhan" target="_blank" rel="noreferrer" aria-label="LinkedIn">LinkedIn</a>
        </div> */}
      </div>
    </footer>
  );
}
